import { IAddress } from "./address";
import { IPayDetails } from "./payDetails";
export class Employee {
   _id: string;
   isActive: boolean;
   name: string;
   profile: string;
   email: string;
   phone: string;
   gender: string;
   designation: string;
   branch: string;
   company: string;
   address: IAddress;
   createdDate: Date;
   modifiedDate: Date;
   createdBy: string;
   modifiedBy: string;
   comments:string;
   userId:string;
   trainerId:string;
   payDetails: IPayDetails[];
   employeeCode: string;
   userCode: number;
}

